import { IntegrationKey, IntegrationProvider } from 'integrations/types'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

const useSaveIntegrationKey = <TConfig = any>(): ((props: {
  provider: IntegrationProvider
  token: string
  enabled: boolean
  config?: TConfig
}) => Promise<IntegrationKey>) => {
  const [request] = useFetchRefactored<IntegrationKey>({
    successMessage: 'Integration Saved',
    errorMessage: 'Failed to save integration',
    useNewNotification: true,
  })
  const org = useCurrentOrg()

  return useCallback(
    ({ provider, token, enabled, config }: { provider: IntegrationProvider; token: string; enabled: boolean; config?: TConfig }) => {
      return request({
        method: 'put',
        url: `/organizations/${org.id}/integration-keys/${provider}`,
        config: {
          body: {
            token,
            enabled,
            ...(config && { config }),
          },
        },
      })
    },
    [org.id, request],
  )
}

export default useSaveIntegrationKey
